import { useState } from 'react';
import { FileDown, RefreshCw } from 'lucide-react';
import toast from 'react-hot-toast';
import { netappAPI } from '@/lib/api/netapp';
import { useDashboardCustomer } from '@/contexts/DashboardCustomerContext';

export function IBReviewAction({ disabled = false }: { disabled?: boolean }) {
  const customer = useDashboardCustomer();
  const [generating, setGenerating] = useState(false);

  const generate = async () => {
    setGenerating(true);
    try {
      await netappAPI.generateIBReview('', customer.customer_name, customer.customer_id);
      toast.success(`IB Review downloaded for ${customer.customer_name}`);
    } catch {
      toast.error('Failed to generate the customer report. Please try again.');
    } finally {
      setGenerating(false);
    }
  };

  return (
    <button type="button" onClick={() => void generate()} disabled={disabled || generating}
      title={`Generate IB Review for ${customer.customer_name}`}
      className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-white bg-gradient-to-r from-[#5869ff] to-[#000742] rounded-lg hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200">
      {generating ? <RefreshCw className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
      {generating ? 'Generating…' : 'Generate IB Review'}
    </button>
  );
}

export default IBReviewAction;
